<template>
  <div id="app">
    <router-view id="padding-scroll-content"></router-view>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data:() => ({
    active: window.location.pathname.split("/")[1],
    isReader: window.location.pathname.split("/")[2] === 'reader',
    isLoggedIn: false,
    searchBar: '',
    activeSearch: false,
    valueSearchBar: '1',
    popupLogin: false,
    popupRegister: false,
    register: {
      email: '',
      nick: '',
      password: '',
      confirmPassword: '',
      termsAndCondition: false
    },
    login: {
      nick: '',
      password: ''
    }
  }),
  beforeMount() {
    this.isLoggedIn = this.$store.state.auth.isLoggedIn;

    Number.prototype.zeroPad = function(length) {
      length = length || 2; // defaults to 2 if no parameter is passed
      return (new Array(length).join('0')+this).slice(length*-1);
    };
  },
  methods: {
    toggleLoginDialog(bool) {
      if (!(bool instanceof Boolean)) return;
      this.popupLogin = bool;
    },
    searchNow() {
      this.activeSearch = false;
      if (this.searchBar === '' || this.searchBar.length <= 2) {
        this.$vs.notification({
          progress: 'auto',
          color: "danger",
          duration: "5000",
          title: 'Búsqueda inválida',
          text: `Debes colocar algo qué buscar.`
        })
      } else {
        if (window.location.pathname.split("/")[1] === 'search') {
          window.location.replace(window.location.origin + "/search?q=" + this.searchBar + "&t=" + this.valueSearchBar);
        } else {
          this.$router.replace({ name: 'buscar', query: { q: this.searchBar, t: this.valueSearchBar } })
        }
        this.searchBar = '';
      }
    },
    enableDialog() {
      this.activeSearch = true;
      setTimeout(function () { document.querySelector('div[placeholder="Buscar"] > .vs-input-content > input').focus() }, 100);
    },
    // async loginSubmit() {
    //   if (this.login.nick === '') {
    //     return this.$vs.notification({
    //       progress: 'auto',
    //       color: "danger",
    //       duration: "5000",
    //       title: 'Indica el usuario',
    //       text: `No has indicado el usuario.`
    //     })
    //   } else if (this.login.password === '') {
    //     return this.$vs.notification({
    //       // 1000,
    //       progress: 'auto',
    //       color: "danger",
    //       duration: "5000",
    //       title: 'Indica tu contraseña',
    //       text: `No te estoy diciendo que esté mal tu contraseña... Si no que ni la has digitado.`
    //     })
    //   }
    //
    //   var usuario = this.login.nick;
    //   var pass = this.login.password;
    //
    //   const params = new URLSearchParams();
    //   params.append('username', usuario);
    //   params.append('password', pass);
    //   // params.append('captcha', captchaRecieved);
    //
    //   await axios
    //       .post('https://api.videnti.co/login', params, { headers: { "Content-Type": 'application/x-www-form-urlencoded' }, withCredentials: true, credentials: "same-origin" })
    //       .then(async resLogin => {
    //         console.log(resLogin.data);
    //         if (resLogin.data.error) {
    //           this.$vs.notification({
    //             progress: 'auto',
    //             color: "danger",
    //             duration: "5000",
    //             title: 'Ocurrió un error',
    //             text: resLogin.data.message
    //           })
    //         } else {
    //           await this.setVuex(resLogin.data)
    //           this.$vs.notification({
    //             // 1000,
    //             progress: 'auto',
    //             color: "success",
    //             duration: "5000",
    //             title: 'Ingresado 🎉',
    //             text: 'Bienvenido, ' + this.$store.state.auth.username,
    //           });
    //           this.popupLogin = false;
    //           this.isLoggedIn = true;
    //           /* await this.$router.push({ name: 'myaccount'}); */
    //         }
    //       }).catch(err => {
    //         return this.$vs.notification({
    //           // 1000,
    //           progress: 'auto',
    //           color: "danger",
    //           duration: "5000",
    //           title: 'Ocurrió un error inesperado',
    //           text: err
    //         })
    //       });
    // },
    async registerSubmit(captchaRecieved) {
      if (this.register.termsAndCondition === false) {
        this.$vs.notification({
          progress: 'auto',
          color: "danger",
          duration: "5000",
          title: 'Requieres aceptar',
          text: `Debes aceptar los Términos y Condiciones del servicio de AnviServer para poder registrarte.`
        })
        return;
      }
      if (this.register.confirmPassword !== this.register.confirmPassword) {
        this.$vs.notification({
          progress: 'auto',
          color: "danger",
          duration: "5000",
          title: 'Contraseñas no coinciden',
          text: `Digita correctamente la misma contraseña en ambos campos.`
        })
        return;
      } else if (this.register.confirmPassword === '') {
        return this.$vs.notification({
          progress: 'auto',
          color: "danger",
          duration: "5000",
          title: 'Indica tu contraseña',
          text: `No te estoy diciendo que esté mal tu contraseña... Si no que ni has digitado una.`
        })
      }
      var usuario = this.register.nick;
      var pass = this.register.password;
      var email = this.register.email;

      const params = new URLSearchParams();
      params.append('username', usuario);
      params.append('password', pass);
      params.append('captcha', captchaRecieved);
      params.append('email', email);

      await axios
          .post('https://api.videnti.co/register', params, { headers: { "Content-Type": 'application/x-www-form-urlencoded' } })
          .then(resRegister => {
            console.log(resRegister.data);
            if (resRegister.data.error) {
              this.$vs.notification({
                // 1000,
                progress: 'auto',
                color: "danger",
                duration: "5000",
                title: 'Ocurrió un error',
                text: resRegister.data.message
              })
            } else {
              this.$vs.notification({
                // 1000,
                progress: 'auto',
                color: "success",
                duration: "5000",
                title: 'Registrado 🎉',
                text: resRegister.data.message
              })
              this.popupRegister = false;
            }
          });
    },
    onSubmit: function () {
      this.$refs.invisibleRecaptcha.execute()
    },
    onVerify: function (response) {
      console.log('Verifying: ' + response);
      this.registerSubmit(response);
    },
    onExpired: function () {
      console.log('Expired')
    },
    async setVuex(par) {
      await this.$store.dispatch('auth/LOGIN_SUCCESS', par);
    },
    logout() {
      this.$store.dispatch('auth/LOGOUT');
      location.reload();
    }
  }
}
</script>
<style>
a {
  color: rgb(var(--vs-primary));
}

.vs-navbar-content {
  /* background: white !important; */
  color: rgb(10,11,14) !important;
  position: fixed !important;
}

.vs-navbar__line {
  background: rgb(10,11,14) !important;
}

.vs-navbar__group__items .vs-navbar__item:before {
  background: rgb(10,11,14) !important;
}

.vs-navbar__group__items {
  background: white !important;
  color: rgb(10,11,14) !important;
  right: 0;
  left: auto !important;
  border-radius: 20px 5px 18px 18px !important;
}

:root {
  --vs-background: 30,32,35 !important;
  /* --vs-text: 255,255,255 !important; */
  --vs-text: 240,248,255 !important; /* aliceblue */
  --vs-text-dark-1: 220,228,235 !important; /* #DCE4EB */
  --vs-text-dark-2: 200,208,215 !important; /* #C8D0D */
  --vs-text-dark-3: 180,187,195 !important; /* #B4BBC3 */
  --vs-gray-1: 24,25,28 !important;
  --vs-gray-2: 20,20,23 !important;
  --vs-gray-3: 15,16,19 !important;
  --vs-gray-4: 10,11,14 !important;
  --vs-shadow-opacity: .3 !important;
  --vs-dark: 0,0,0 !important;
  --vs-background-opacity: .6 !important;
  /* --publisher-color: var(--vs-primary);
  --publisher-color-safe: var(--vs-primary); */
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* color: aliceblue; */
  color: rgb(var(--vs-text))
  /* background-color: #2e2d2d; */
}
/* .navMargin { margin-top: 80px !important; } */
.navMargin { margin-top: 100px !important; }
.navMarginSmall { margin-top: 60px !important; }
.centrar { text-align: center; }

html {
  /* background-color: black; */
  background-color: #141414;
}
#app, button, html {
  font-family: Poppins, Avenir, Helvetica, Arial, sans-serif;
}

.banner-anm {
  padding-top: 65px;
}
.banner .banner-img {
  position: relative;
}
.banner-anm .banner-img {
  position: relative;
  min-height: 654px;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  /*background-position: center center;*/
  /*background-size: auto 760px;*/
}
/* SCROLL */
/* Tamaño del scroll */
html::-webkit-scrollbar {
  width: 8px;
}

/* Estilos barra (thumb) de scroll */
html::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 4px;
}

html::-webkit-scrollbar-thumb:active {
  background-color: #999999;
}

html::-webkit-scrollbar-thumb:hover {
  background: #b3b3b3;
  box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.2);
}

/* Estilos track de scroll */
html::-webkit-scrollbar-track {
  background: #000;
  border-radius: 4px;
}

html::-webkit-scrollbar-track:hover,
html::-webkit-scrollbar-track:active {
  background: #000;
}

@media only screen and (max-width: 645px) {
  .hideWhenSmall {
    display: none !important;
  }
}

@media only screen and (min-width: 645px) {
  .showWhenSmall {
    display: none;
  }
}

.animacion-enlace {
  /* display: inline-block; */
  position: relative;
  color: #0087ca;
  cursor: pointer;
  color: rgba(var(--vs-primary));
  text-decoration-line: none;
}

.animacion-enlace:after {
  content: '';
  position: absolute;
  width: 100%;
  transform: scaleX(0);
  height: 1px;
  bottom: 0;
  left: 0;
  background-color: #0087ca;
  transform-origin: bottom right;
  transition: transform 0.25s ease-out;
}

.animacion-enlace:hover:after {
  transform: scaleX(1);
  transform-origin: bottom left;
}

.remove-scroll .vs-card__group-cards::-webkit-scrollbar {
  height: 0 !important;
}

.ratio {
  position: relative;
  width: 100%;
}

.ratio-16x9 {
  --bs-aspect-ratio: calc(9 / 16 * 100%);
}

@media (max-width: 600px) {
  .ratio-16x9.invert-small {
    --bs-aspect-ratio: calc(16 / 9 * 100%);
  }

  .ratio-9x16.invert-small {
    --bs-aspect-ratio: calc(9 / 16 * 100%);
  }
}

.ratio-9x16 {
  --bs-aspect-ratio: calc(16 / 9 * 100%);
}

.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}

.ratio>* {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio>img {
  object-fit: cover;
}

.vs-table table {
  min-width: unset !important;
}

.vs-select-content {
  max-width: unset !important;
}
</style>
